<div class="filters-wrapper ps-5">
  <span class="mb-4 mt-5">{{ "Energy trajectory calculation" | translate }}:</span>
  <nb-radio-group name="energyConsumptionType"
    class="filters-container"
    [(ngModel)]="energyConsumptionType"
    (click)="filterChanged('energy')"
    [disabled]="(canEdit$ | async) === false"
  >
    @for (option of options; track option.value) {
        <nb-radio [value]="option.value">
            {{ option.label | translate }}
        </nb-radio>
    }
  </nb-radio-group>

  <span class="mb-4 carbon">{{ "Carbon trajectory calculation" | translate }}:</span>
  <nb-radio-group name="carbonConsumptionType"
    class="filters-container"
    [(ngModel)]="carbonConsumptionType"
    (click)="filterChanged('carbon')"
    [disabled]="(canEdit$ | async) === false"
  >
    @for (option of options; track option.value) {
      <nb-radio [value]="option.value">
          {{ option.label | translate }}
      </nb-radio>
    }
  </nb-radio-group>
</div>
